export class ErpAiService {
    public static serviceName = 'erpAiService';

    private static readonly SCANNING_OVERLAY_CLASS = 'erp-ai-rainbow-overlay-effect';

    public toggleScanningOverlay(element: Element): void {
        element.classList.toggle(ErpAiService.SCANNING_OVERLAY_CLASS);
    }
}